import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import CentersPage from "./pages/CentersPage";
import AboutPage from "./pages/AboutPage";
import LegalPage from "./pages/LegalPage";
import QuestionnaireListPage from "./pages/QuestionnaireListPage";
import QuestionnaireFormPage from "./pages/QuestionnaireFormPage";
import AdminPage from "./pages/AdminPage";
import ProfessionalsPage from "./pages/ProfessionalsPage";
import SignalsPage from "./pages/SignalsPage";
import SatisfactionSurveyPage from "./pages/SatisfactionSurveyPage";
import FAQPage from "./pages/FAQPage";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import ScrollToTop from "./components/ScrollToTop";
import PatientsZoneBanner from "./components/PatientsZoneBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <PatientsZoneBanner />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/servicios" element={<ServicesPage />} />
          <Route path="/centros" element={<CentersPage />} />
          <Route path="/nosotros" element={<AboutPage />} />
          <Route path="/profesionales" element={<ProfessionalsPage />} />
          <Route path="/sintomas" element={<SignalsPage />} />
          <Route path="/síntomas" element={<SignalsPage />} />
          <Route path="/senales" element={<SignalsPage />} />
          <Route path="/señales" element={<SignalsPage />} />
          <Route path="/encuesta-satisfaccion" element={<SatisfactionSurveyPage />} />
          <Route path="/encuesta" element={<SatisfactionSurveyPage />} />
          <Route path="/preguntas-frecuentes" element={<FAQPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/aviso-legal" element={<LegalPage slug="aviso-legal" />} />
          <Route path="/politica-cookies" element={<LegalPage slug="politica-cookies" />} />
          <Route path="/politica-privacidad" element={<LegalPage slug="politica-privacidad" />} />
          <Route path="/cuestionarios" element={<QuestionnaireListPage />} />
          <Route path="/cuestionarios/:qid" element={<QuestionnaireFormPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <Footer />
        <WhatsAppFloat />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
